import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/types/queryKey';
import { getTask } from '@/lib/services';

export function useGetTask(
  taskId: string,
  isCompleted: boolean,
  refetchInterval: number = 4000
) {
  return useQuery({
    queryKey: [QueryKey.Task, taskId],
    queryFn: () => getTask(taskId),
    enabled: !!taskId,
    refetchInterval: isCompleted ? 0 : refetchInterval,
  });
}
